import { render, staticRenderFns } from "./StockBrowserBranchList.vue?vue&type=template&id=03862d25&scoped=true&"
import script from "./StockBrowserBranchList.vue?vue&type=script&lang=js&"
export * from "./StockBrowserBranchList.vue?vue&type=script&lang=js&"
import style0 from "./StockBrowserBranchList.vue?vue&type=style&index=0&id=03862d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03862d25",
  null
  
)

export default component.exports